<template>
    <ion-header v-if="isAuthenticated">
        <svg class="header-logo"
             @click="reloadProfile($event)"
             :class="{'disabled': disabled}">
            <use xlink:href="#portalgastro-logo"></use>
        </svg>
        <div v-if="!disabled"
             class="header-notification"
             @click="goTo('Notifications')">
            <span v-if="unread_notifications > 0" class="counter">{{ unread_notifications }}</span>
            <svg class="icon icon-bell"><use xlink:href="#icon-bell"></use></svg>
        </div>
        <div v-if="downloadsEnabled && !disabled"
             class="header-downloads"
             @click="goTo('Downloads')">
            <svg class="icon icon-download-outline"><use xlink:href="#icon-download-outline"></use></svg>
        </div>
    </ion-header>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import goTo from '@/mixins/goto';

    export default {
        name: 'MainHeader',
        mixins: [goTo],
        computed: {
            ...mapGetters(['isAuthenticated']),
            ...mapState({
                disabled: state => state.profile.header_disabled,
                notifications: state => state.profile.notifications,
                unread_notifications: state => state.profile.unread_notifications,
                cart: state => state.shopGlass.cart,
                navigation: state => state.config.navigation
            }),
            downloadsEnabled(){
                let result = null
                Object.entries(this.navigation).forEach(([key, arr]) => {
                  arr.forEach((item) => {
                     if(item.route === "Downloads"){
                       return result = (item.disabled == false) ? true : false
                     }
                  })
              })
              return result
            }
        },
        methods: {
            reloadProfile(e){
                // requested: reload all profile data
                this.$store.dispatch('profile/PROFILE_REQUEST').then(() => {
                  this.$store.dispatch('profile/PROFILE_NOTIFICATIONS_REQUEST').then(() => {
                    this.goTo('Index')
                  })
                })
            }
        }
    }
</script>
